/**
 * Anthropic adapter — exists so `Record<Provider, ProviderAdapter>` is total
 * after Anthropic was added to the `Provider` union for BYOK key storage.
 *
 * Anthropic isn't part of the image / video / audio / 3D generator routing;
 * its key is consumed by the coding-models pathway at src/code/codingModels.ts
 * (Claude Opus / Sonnet) and as the director when `directorAgent === 'claude'`.
 *
 * `models: []` ensures the orchestrator's `decide()` never recommends it for
 * generation modes. `generate()` returns a structured `failed` result with a
 * clear message rather than throwing — same contract as every other adapter.
 */
import type {
  ProviderAdapter,
  ModelDescriptor,
  GenerateRequest,
  GenerateResult,
} from '../router/types';
import { fail } from './common';

export const ANTHROPIC_MODELS: ModelDescriptor[] = [];

export const anthropic: ProviderAdapter = {
  id: 'anthropic',
  models: ANTHROPIC_MODELS,
  async generate(
    _modelId: string,
    _req: GenerateRequest,
    _apiKey: string,
  ): Promise<GenerateResult> {
    return fail(
      'anthropic provider is reserved for coding chat (open the <> popup in the chat input) and for the claude director option. Generator routing does not use it directly.',
    );
  },
};